
import React, { useEffect, useState, useContext, useCallback, useRef } from 'react';
import { StepFourFooterRightSide } from './styles';
import { useHistory } from 'react-router';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { getActivities } from '../../../services/actividades';
import { getSimulacionEdades } from '../../../services/simulation';
import { calculateDate } from '../../../helpers/date';
import { SimulatorContext } from '../../../store/';
import { default as SimulatorTypes } from '../../../store/Simulator/types';
import Select from '../../../components/Select';
import InputDefault from '../../../components/InputDefault';
import InputDate from '../../../components/InputDate';
import InputPhone from '../../../components/InputPhone';
import RadioButtonForm from '../../../components/RadioButtonForm';
import CheckBox from '../../../components/CheckBox';
import { identificationType, simulatorSteps, contactMeans, creditLinesBack, idTypes } from '../../../helpers/enum';
import { handleChangeIdentification } from '../../../helpers/price';
import { DefaultLargeButton, SecondaryLargeButton, TertiaryLargeButton, DefaultSmallButton } from '../../../components/Buttons/styles';
import { saveSimulationResult } from '../../../services/simulation';

import FormTemplate from '../../../components/FormTemplate';
import { Form, FormFooter, FormRow, FormRowInvisible } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import colors from '../../../assets/styles/colors';
import { BsExclamation, BsCheck } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import { getClientDataFull } from '../../../services/clients';
import { getLastCreditByClient } from '../../../services/credit';
import { postRiskLevelSoyYo } from '../../../services/soyYo';
import { getPiloto, getPilotoValidacionIdentidad } from '../../../services/desk';
import InputDefaultOnlyText from '../../../components/InputDefaultOnlyText';
import { getDominioCorreo } from '../../../services/dominioCorreo';
import { getIdentificationTypes } from '../../../services/calculator';
import { getDestinosCredito } from '../../../services/habeasData';
import SearchField from '../../../components/SearchField';
import SearchFieldCategories from '../../../components/SearchFieldCategories';
import infoCircle from '../../../assets/images/info-circle.svg';
import { InfoCircleImage } from '../Result/styles';
import imagenCedula from '../../../assets/images/cedula-normativa.jpg'
import ModalInfoImage from '../../../components/ModalInfoImage';
import { getContratoAsesor } from '../../../services/advisor';
import ModalAction from '../../../components/ModalAction';
import LoadingModal from '../../../components/ModalFlujoContinuo';
import ModalFlujoContinuoError from '../../../components/ModalFlujoContinuoError';
import flujoContinuoTimeOutImg from '../../../assets/images/flujo-continuo-timeout.png';
import falloCentralesImg from '../../../assets/images/fallo-centrales.png';

const ClientDataPage = ({ setActiveStep, setLastStep, setDeskError, setShowModal }) => {
  const history = useHistory();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const location = useLocation();
  const { simulator, setSimulator } = useContext(SimulatorContext);
  const { register, handleSubmit, watch, setValue, control, clearErrors, errors } = useForm({ defaultValues: simulator.clientData });
  const fields = watch();
  const [paymentBill, setPaymentBill] = useState([]);
  const [activities, setActivities] = useState([]);
  const [showActivity, setShowActivity] = useState(false);
  const [showContactMean, setShowContactMean] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInfoEdad, setShowModalInfoEdad] = useState(false);
  const [showModalInfoCapacity, setShowModalInfoCapacity] = useState(false);
  const [showModalIdValidation, setShowModalIdValidation] = useState(false);
  const [permission, setPermission] = useState(false);
  const [minAgeAllowed, setminAgeAllowed] = useState(0);
  const [maxAgeAllowed, setmaxAgeAllowed] = useState(0);
  const [idCurrentSimulation, setIdCurrentSimulation] = useState('');
  const [tipoDocumento, setTipoDocumentos] = useState([{ id: 'CC', nombre: 'Cédula de ciudadanía', label: 'CC', value: 'CC' }]);
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [showModalSoyYo, setShowModalSoyYo] = useState(false);
  const [descriptionModalSoyYo, setDescriptionModalSoyYo] = useState('');
  const emailValue = useWatch({ control, name: 'email' });
  const [whatsApp, setWhatsApp] = useState(false);
  const [pilotoSoyYo, setPilotoSoyYo] = useState(false);
  const [showDominioCorreo, setShowDominioCorreo] = useState(false);
  const [anotherDominioCorreo, setAnotherDominioCorreo] = useState(false);
  const [dominiosCorreo, setDominiosCorreo] = useState([]);
  const [showDominioCorreo2, setShowDominioCorreo2] = useState(false);
  const emailValue2 = useWatch({ control, name: 'email2' });
  const [showModalInfoCorreo, setShowModalInfoCorreo] = useState(false);
  const dominioValue = useWatch({ control, name: 'dominioCorreoNuevo' });
  const dominioValue2 = useWatch({ control, name: 'dominioCorreoNuevo2' });
  const [destinosCredito, setDestinosCredito] = useState([]);
  const [showDestinosCredito, setShowDestinosCredito] = useState(false);
  const [filteredDominiosCorreo, setFilteredDominiosCorreo] = useState([]);
  const [titleValidation, setTitleValidation] = useState(false);
  const [messageValidation, setMessageValidation] = useState(false);
  const [preSelectedDestinoCredito, setPreSelectedDestinoCredito] = useState(false);
  const [showIdType, setShowIdType] = useState(false);
  const [showModalIdType, setShowModalIdType] = useState(false);
  const [showModalCorretaje, setShowModalCorretaje] = useState(false);
  const [errores, setErrores] = useState([]);
  const [showModalCambioAsesor, setShowModalCambioAsesor] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idCredito, setIdCredito] = useState(false);
  const LABELS = [
    "Validando datos personales...",
    "Consultando centrales de riesgo...",
    "Validando historial crediticio...",
    "Procesando huellas de consulta...",
    "Consultando procesos jurídicos...",
    "Procesando solicitud de crédito..."
  ];
  const [enableCloseModal, setEnableCloseModal] = useState(false);
  const [showModalTimeOut, setShowModalTimeOut] = useState(false);
  const [showModalFalloTecnico, setShowModalFalloTecnico] = useState(false);

  const TIMEOUT_DURATION = 90 * 1000;
  const TIMERMODALERROR_DURATION = 10000;

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      setSimulator({
        type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
        tipoIdentificacion: { id: 'CC', nombre: 'Cédula de ciudadanía', label: 'CC', value: 'CC' }
      })
      const identificationTypes = await getIdentificationTypes();
      setTipoDocumentos(identificationTypes.data);
      const isPiloto = await getPiloto(simulator.desk.id);
      setPilotoSoyYo(isPiloto.data.isValidadorSoyYo);
      setWhatsApp(isPiloto.data.isValidadorSoyYo);
      if (simulator.clientData.pagaduria) {
        setValue("pagaduria", simulator.clientData.pagaduria.nombre);
      }
      const dominiosCorreo = await getDominioCorreo();
      const destinoCredito = await getDestinosCredito();
      const modifiedData = destinoCredito.data.map(item => ({
        ...item,
        nombre: item.destinoCredito
      }));
      const pilotoValidadcionIdentidad = await getPilotoValidacionIdentidad(simulator.desk.id);
      if(!pilotoValidadcionIdentidad.data.unificado){
        setTitleValidation('Registro Exitoso');
        setMessageValidation("Puedes retomar el crédito en Pendientes por radicar.");
      }else{
        setTitleValidation('Validación de identidad');
        setMessageValidation("Enviamos una notificación al cliente a través de WhatsApp y correo electrónico para que realice la validación de identidad. Consulta el estado del crédito en el menú Pendientes por radicar")
      }

      setDestinosCredito(modifiedData);
      setDominiosCorreo(dominiosCorreo.data);
      console.log(simulator.clientData.email);
      setValue('email',simulator.clientData.email)
      
      /*if(simulator.clientData.email){
        const formaCorreo = simulator.clientData.email.split('@');
        simulator.clientData.email = formaCorreo[0];
        simulator.clientData.dominioCorreo = '@'+formaCorreo[1];
      }
      const dominioEncontrado = dominiosCorreo.data.find(correo => simulator.clientData.dominioCorreo === correo.nombre)
      if(dominioEncontrado){
        setValue('email',simulator.clientData.email)
        setSelectedDominioCorreo(dominioEncontrado)
      }*/
      
      if (simulator.clientData.departamento) {
        setValue("departamento", simulator.clientData.departamento.id);
      }

      const activities = await getActivities();

      const ages = await getSimulacionEdades();
      setminAgeAllowed(ages.min);
      setmaxAgeAllowed(ages.max);

      if (location.idSimulation) {
        if (simulator.clientData.actividadCliente && !simulator.clientData.actividadCliente.id) {
          const actividad = activities.data.find(item => item.id === simulator.clientData.actividadCliente);
          setSelectedActivitie(actividad);
        }

        handleCalculateDate();
      }
      if(simulator.financesData.lineaCredito.idBackend == 6){
        setSelectedDestinoCredito({id: 2,nombre: "Educación"})
        setPreSelectedDestinoCredito(true)
      }
      if(simulator.financesData.lineaCredito.idBackend == 7){
        setSelectedDestinoCredito({id: 10,nombre: "Actividades Productivas"})
        setPreSelectedDestinoCredito(true)
      }
      setPaymentBill(paymentBill.data);
      setActivities(activities.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }


  function initSolicitation() {
    initSimulation();
  }

  function checkCapacity() {
    return parseInt(simulator.simulation.remanenteEstimado) > 0 &&
      parseInt(simulator.simulation.montoMaximoSugerido) >= parseInt(simulator.simulation.remanenteEstimado);
  }

  function showModalID() {
    setShowModalIdType(true)
  }

  function saveSimulationBody(isForSolicitation) {
    const req = {
      idSimulacion: history.location.idSimulation,
      idPagaduria: simulator.clientData.pagaduria.id,
      idAsesor: session.idAsesor,
      idOficina: simulator.desk.id,
      idLineaCredito: simulator.financesData.lineaCredito.idBackend,
      subCanal: 'WEB',
      actividadCliente: simulator.clientData.actividadCliente.id,
      tasa: parseFloat(simulator.priceValueToSolicitate.tasa.id),
      plazo: parseInt(simulator.priceValueToSolicitate.plazo),
      monto: parseInt(simulator.priceValueToSolicitate.monto),
      diasInteresesIniciales: parseInt(simulator.priceValueToSolicitate.diasInteresesIniciales),
      ingresos: parseInt(simulator.financesData.ingresos),
      descuentosLey: (simulator.financesData.descuentosLey) ? parseInt(simulator.financesData.descuentosLey) : 0,
      descuentosNomina: (simulator.financesData.descuentosNomina) ? parseInt(simulator.financesData.descuentosNomina) : 0,
      //destinoCredito: simulator.financesData.destinoCredito.id,
      medioContacto: simulator.clientData.medioContacto.id,
      carteras: simulator.simulation.carteras,
      cliente: {
        primerNombre: fields.primerNombre,
        segundoNombre: fields.segundoNombre,
        primerApellido: fields.primerApellido,
        segundoApellido: fields.segundoApellido,
        nombres: fields.nombres,
        tipoIdentificacion: simulator.clientData.tipoIdentificacion.value,
        identificacion: parseInt(fields.identificacion.replaceAll(".", "")),
        fechaNacimiento: fields.fechaNacimiento ? fields.fechaNacimiento : simulator.clientData.fechaNacimiento,
        celular: fields.celular.replaceAll(" ", ""),
        email: fields.email,
        idCiudad: simulator.clientData.ciudad.id,
        departamento: simulator.clientData.departamento.id,
        tipoDocumentoIdentidad: simulator.clientData.tipoCedula?.id
      },
      departamento: simulator.clientData.departamento.id,
      ciudad: simulator.clientData.ciudad,
      validarIdentidad: isForSolicitation,
      genero: simulator.clientData.genero.idLegado,
      totalActivos: simulator.priceValueToSolicitate.totalActivos,
      estrato: simulator.clientData.estrato?.nombre,
      productPricing: simulator.priceValueToSolicitate.pricingProduct,
      nivelEducativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
      tipoContrato: simulator.priceValueToSolicitate.tipoContrato?.nombre,
      canalWhatsApp: whatsApp,
      destinoCreditoCliente: {
        destino:simulator.clientData.destinoCredito?.nombre,
        idDestino:simulator.clientData.destinoCredito?.id
      },
      bonoSocial: simulator.priceValueToSolicitate.bonoSocial,
      capacidadCliente: simulator.priceValueToSolicitate.capacidadCliente
    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.idCreditoPadre = getListofCredits().map(credito => credito.id)
    }

    return req;
  }

  function getListofCredits() {
    return (simulator.financesData.credits.length === undefined) ? [simulator.financesData.credits] : simulator.financesData.credits;
  }

  async function saveSimulation() {
    try {
      setIsLoading(true);
      const req = saveSimulationBody(false);
      const response = await saveSimulationResult(req);
      setIdCurrentSimulation(response.data.idSimulacion);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }
  
  async function initSimulation() {
    try {
      setIsLoading(true);
      const req = saveSimulationBody(true);
      const response = await saveSimulationResult(req);
      setIdCredito(response.data.idCredito)

      if(response.data.tipo == 'VALIDACIONES_FALLIDAS_POLITICA'){
        setErrores(response.data.errores);
        setShowModalCambioAsesor(true);
      }
      setIsLoading(false);

      let dataa = {
        documentType: "CC",
        identificationNumber: fields.identificacion.replaceAll(".", ""),
        data: {
          country_code: "+57",
          phone: fields.celular.replaceAll(" ", ""),
          email_address: fields.email,
          name: fields.primerNombre,
          lastname: fields.primerApellido
        }
      }

      setIsLoading(true);
      const responseSoyYo = await postRiskLevelSoyYo(dataa)
      setIsLoading(false);

      if (responseSoyYo.data) {
        setDescriptionModalSoyYo(<><div>En la validación de la información de contacto registrada para el trámite de crédito del cliente <b>{fields.primerNombre} {fields.primerApellido}</b>  hemos identificado diferencias. </div>
          <br></br>
          <div>Ahora mismo, podrás continuar con el proceso de perfilamiento y simulación. Sin embargo, para poder evaluar la solicitud de crédito es indispensable que el cliente se acerque a una de nuestras oficinas para realizar el  proceso de autenticación biométrico y registro de datos de contacto.</div>
          <br></br>
          <div>Te agradecemos brindar acompañamiento al cliente en este proceso.</div>
        </>)
        //setShowModalSoyYo(true)
      }

      await setIdCurrentSimulation(response.data.idSimulacion);
      setIsLoading(true);
      const responseContratoAsesor = await getContratoAsesor(session.idAsesor)
      if(!responseContratoAsesor.data){
        setShowModalCorretaje(true);
      }
      handleOpenModal();
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
      console.log(error.response)
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setShowModalTimeOut(false);

    
    setTimeout(() => {
      setIsModalOpen(false);
      handleOpenModalError();
    }, TIMEOUT_DURATION);
  };

  const handleOpenModalError = () => {
    setShowModalTimeOut(true);
    setEnableCloseModal(true);

    setTimeout(() => {
      setShowModalTimeOut(false);
      setIsModalOpen(true);
    }, TIMERMODALERROR_DURATION);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    history.push({
      pathname: '/admin/client-registration',
      step: 5,
      idCredit: idCredito
    });
  };

  async function solicitudCambioAsesor() {

    history.push({
      pathname: '/admin/dashboard/'
    });
  }

  function moveToDashboard() {

    history.push({
      pathname: '/admin/dashboard/'
    });
  }

  function setIdentificationRadioChecked(radio) {
    setSimulator({
      type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
      tipoIdentificacion: radio,
      identificacion: ''
    })
    setValue('identificacion', '');
  }

  function setCompleteStep(data) {
    data.tipoIdentificacion = simulator.clientData.tipoIdentificacion.value;
    data.actividadCliente = fields.actividadCliente;
    data.edad = fields.edad;
    data.pagaduria = fields.pagaduria;
    data.medioContacto = fields.medioContacto;
    data.desk = simulator.desk;

    if (simulator.desk !== '') {
      setDeskError({});
      setSimulator({
        type: SimulatorTypes.SET_CLIENT_DATA,
        clientData: data
      });
    } else {
      setIsLoading(false);
      setDeskError({ required: true, message: 'Este dato es obligatorio' });
      return;
    }

    if (fields.edad < minAgeAllowed || fields.edad > maxAgeAllowed) {
      setShowModalInfoEdad(true);
      return;
    }
    //mandar mail
    //terminar pasos


    setActiveStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
    setLastStep(simulatorSteps.CLIENT_DATA);
  }

  function setBackStep() {
    setActiveStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
  }

  function handleCalculateDate() {
    let years = calculateDate(fields.fechaNacimiento);
    setValue("edad", years);

    setSimulator({
      type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
      edad: years
    })
  }

  function toUpperFirst(str) {
    return str == '' || str == null ? str :
      str[0].toUpperCase() + (str.length > 1 ? str.substring(1).toLowerCase() : '');
  }

  function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});

    setSimulator({
      type: SimulatorTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    })
  }

  function setSelectedDominioCorreo(dominioCorreo) {
    setValue("dominioCorreo", dominioCorreo.nombre);
    clearErrors("dominioCorreo", {});
    dominioCorreo.nombre == 'Agregar otro dominio' ? setAnotherDominioCorreo(true) : setAnotherDominioCorreo(false)
    setSimulator({
      type: SimulatorTypes.SET_DOMINIO_CORREO,
      dominioCorreo: dominioCorreo
    })
    setShowDominioCorreo2(false)
  }

  function setSelectedDestinoCredito(destinoCredito) {
    setValue("destinoCredito", destinoCredito);
    clearErrors("destinoCredito", {});

    setSimulator({
      type: SimulatorTypes.SET_DESTINO_CREDITO,
      destinoCredito: destinoCredito
    })
  }

  function setContactMean(contactMean) {
    setValue("medioContacto", contactMean);
    clearErrors("medioContacto", {});

    setSimulator({
      type: SimulatorTypes.SET_CONTACT_MEAN,
      medioContacto: contactMean
    })
  }

  function setIdType(tipoCedula) {
    setValue("tipoCedula", tipoCedula);
    clearErrors("tipoCedula", {});

    setSimulator({
      type: SimulatorTypes.SET_ID_TYPE,
      tipoCedula: tipoCedula
    })
  }

  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value.toLowerCase();
    setValue('email', lowercaseEmail);
  };

  useEffect(() => {
    const lowercaseEmail = emailValue?.toLowerCase();
    setValue('email', lowercaseEmail);
  }, [emailValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = emailValue2?.toLowerCase();
    setValue('email2', lowercaseEmail);
  }, [emailValue2, setValue]);

  useEffect(() => {
    const lowercaseEmail = dominioValue?.toLowerCase();
    setValue('dominioCorreoNuevo', lowercaseEmail);
  }, [dominioValue, setValue]);

  useEffect(() => {
    const lowercaseEmail = dominioValue2?.toLowerCase();
    setValue('dominioCorreoNuevo2', lowercaseEmail);
  }, [dominioValue2, setValue]);



  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion.value === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion);
  }

  async function onChangePermission(e) {
    await setPermission(!permission);
  }

  async function onChangeWhatsApp(e) {
    await setWhatsApp(e.value);
  }

  useEffect(() => {
    initializedStateComponent();
    return () => {
      setPaymentBill([]);
      setActivities([]);
    }
  }, []);

  useEffect(() => {
    setValue("dominioCorreoNuevo",'@')
    setValue("dominioCorreoNuevo2",'@')
  }, [anotherDominioCorreo]);

  function moveToDashboard() {
    history.push({
      pathname: '/admin/identity-validation/',
      idSimulation: simulator
    });
  }


  const handleCopy = (event) => {
    event.preventDefault();
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  function searchInDominios(e) {
    setShowDominioCorreo2(true);
    let filtered = dominiosCorreo.filter(dominio => dominio.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDominiosCorreo(filtered);
  }


  useEffect(() => {
    const validarDominio = true;//anotherDominioCorreo ? ((fields.dominioCorreoNuevo !== '@') && (fields.dominioCorreoNuevo2 !== '@')) : true;
    if(fields.identificacion && fields.primerNombre && fields.primerApellido && fields.email && fields.celular && simulator.clientData.medioContacto 
      && simulator.clientData.destinoCredito?.nombre && simulator.clientData.tipoCedula?.nombre
       /*fields.email2 && validarDominio && simulator.clientData.dominioCorreo?.nombre*/){
      setPermission(true);
    }else{
      setPermission(false);
    }
  }, [fields.identificacion, fields.primerNombre, fields.primerApellido, fields.email, fields.celular, simulator.clientData.medioContacto,
    fields.email2,fields.dominioCorreoNuevo2,fields.dominioCorreoNuevo,anotherDominioCorreo, simulator.clientData.destinoCredito?.nombre, simulator.clientData.tipoCedula?.nombre]);

  return (
    <FormTemplate
      idForm="client-data-step-lage"
      idButton="new-simulation"
      labelButton="Nueva simulación"
      activeStep="2/2"
      stepLabel="Datos cliente"
      actionHeaderButton={setShowModal}>
      <FormRow>
        <Select
          error={errors.tipoDocumento}
          setShow={setShowTipoDocumentos}
          show={showTipoDocumentos}
          defaultValue={simulator.clientData.tipoIdentificacion?.nombre}
          setSelected={setIdentificationRadioChecked}
          list={tipoDocumento}
          placeholder="Seleccionar..."
          label="Tipo de documento"
          name="tipoIdentificacion"
          id="tipoIdentificacion"
          register={register({ required: "Este dato es obligatorio" })}
          disabled={true}
        />
        <Controller
          name="identificacion"
          control={control}
          value={simulator.clientData.identificacion}
          render={() => (
            <InputDefault
              name="identificacion"
              label="Número de documento de identidad"
              register={register({
                required: "Este dato es obligatorio",
                pattern: {
                  value: /^\d+(\.\d+)*$/,
                  message: "Error en el número, ingresa uno válido",
                }
              })}
              id="identificacion"
              error={errors.identificacion}
              maxLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.max : identificationType.cc.max}
              minLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.min : identificationType.ce.min}
              onChange={onChangeIdentification}
              readOnly={true}
            />
          )}
        />
      </FormRow>
      <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
        <FormRow col="2">
          <Controller
            as={InputDefaultOnlyText}
            control={control}
            label="Primer Nombre"
            name="primerNombre"
            register={register({ required: "Este dato es obligatorio" })}
            id="primerNombre"
            error={errors.primerNombre}
            value={simulator.clientData.primerNombre} />
          <Controller
            as={InputDefaultOnlyText}
            control={control}
            label="Segundo Nombre"
            name="segundoNombre"
            register={register}
            id="segundoNombre"
            value={simulator.clientData.segundoNombre} />
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefaultOnlyText}
            control={control}
            label="Primer Apellido"
            name="primerApellido"
            register={register({ required: "Este dato es obligatorio" })}
            id="primerApellido"
            error={errors.primerApellido}
            value={simulator.clientData.primerApellido} />
          <Controller
            as={InputDefaultOnlyText}
            control={control}
            label="Segundo Apellido"
            name="segundoApellido"
            register={register}
            id="segundoApellido"
            value={simulator.clientData.segundoApellido} />
        </FormRow>
        {!simulator.pricing &&
          <FormRow col="2">
            <InputDate
              aria-required
              type="date"
              label="Fecha de nacimiento"
              name="fechaNacimiento"
              register={register({ required: "Este dato es obligatorio" })}
              id="fechaNacimiento"
              onBlur={handleCalculateDate}
              error={errors.fechaNacimiento} />
            <Controller
              as={InputDefault}
              control={control}
              label="Edad cliente"
              name="edad"
              register={register}
              id="yearsold"
              error={errors.edad}
              readOnly={true}
              value={simulator.clientData.edad} />
          </FormRow>}
          <FormRow col="2">
          <Controller
          readOnly
            as={InputPhone}
            control={control}
            label="Celular"
            name="celular"
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                message: "Error en el número, ingresa uno válido",
              },
            })}
            id="celular"
            error={errors.celular}
            mask="999 999 99 99"
            value={simulator.clientData.celular} />
          </FormRow>
          <FormRow>
          <Controller
          readOnly
            as={InputDefault}
            control={control}
            label="Correo Electrónico"
            name="email"
            onChange={onChangeEmail}
            onCopy={handleCopy}
            onPaste={handlePaste}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "El correo electrónico tiene un formato inválido",
              },
            })}
            id="email"
            error={errors.email}
            value={simulator.clientData.email}
          />
           <Select
              error={errors.destinoCredito}
              setShow={setShowDestinosCredito}
              show={showDestinosCredito}
              defaultValue={simulator.clientData.destinoCredito?.nombre}
              setSelected={setSelectedDestinoCredito}
              list={destinosCredito}
              placeholder="Seleccionar..."
              label="Destino Credito"
              name="destinoCredito"
              id="destinoCredito"
              register={register({ required: "Este dato es obligatorio" })} 
              disabled={preSelectedDestinoCredito}/>
          </FormRow>
{/** 
        <FormRow col="3">
          

            <Controller
            as={InputDefault}
            control={control}
            label="Correo Electrónico"
            name="email"
            onChange={onChangeEmail}
            onCopy={handleCopy}
            onPaste={handlePaste}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "El correo electrónico tiene un formato inválido",
              },
            })}
            id="email"
            error={errors.email}
            value={simulator.clientData.email}
          />
            <SearchFieldCategories
              subcategory1={'Dominios 1'}
              subcategory2={'Dominios 2'}
              label="Dominio Correo Electrónico"
              name="dominioCorreo"
              id="dominioCorreo"
              show={showDominioCorreo2}
              list={filteredDominiosCorreo}
              list2={filteredDominiosCorreo}
              defaultValue={simulator.clientData.dominioCorreo?.nombre}
              setSelected={setSelectedDominioCorreo}
              selectField={setSelectedDominioCorreo}
              searchInList={searchInDominios}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.dominioCorreo} />
          {anotherDominioCorreo && 
          <Controller
            as={InputDefault}
            control={control}
            label="Dominio Correo Electrónico"
            name="dominioCorreoNuevo"
            onChange={onChangeEmail}
            onCopy={handleCopy}
            onPaste={handlePaste}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                message: "El dominio del correo electrónico tiene un formato inválido"
              }
            })}
            id="dominioCorreoNuevo"
            error={errors.dominioCorreoNuevo}
            value={simulator.clientData.dominioCorreoNuevo}
          />}
        </FormRow>
         
        <FormRow col="3">
        <Controller
            as={InputDefault}
            control={control}
            onCopy={handleCopy}
            onPaste={handlePaste}
            label="Confirmar Correo Electrónico"
            name="email2"
            //onChange={onChangeEmail}
            register={register({
              required: "Este dato es obligatorio",})}
            id="email2"
            error={errors.email}
            value={simulator.clientData.email}
            onBlur={onBlurEmail2}
          />
          <SearchFieldCategories
              subcategory1={'Dominios 1'}
              subcategory2={'Dominios 2'}
              label="Confirmar Dominio Correo Electrónico"
              name="dominioCorreo2"
              id="dominioCorreo2"
              show={showDominioCorreo2}
              list={filteredDominiosCorreo}
              defaultValue={simulator.clientData.dominioCorreo?.nombre}
              setSelected={setSelectedDominioCorreo}
              selectField={setSelectedDominioCorreo}
              searchInList={searchInDominios}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.dominioCorreo} />
          {anotherDominioCorreo && 
          <Controller
            as={InputDefault}
            control={control}
            onCopy={handleCopy}
            onPaste={handlePaste}
            label="Confirmar Dominio Correo Electrónico"
            name="dominioCorreoNuevo2"
            onChange={onChangeEmail}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
                message: "El dominio del correo electrónico tiene un formato inválido"
              }
            })}
            id="dominioCorreoNuevo2"
            error={errors.dominioCorreoNuevo}
            value={simulator.clientData.dominioCorreoNuevo}
          />}
        </FormRow>*/}
        {!simulator.pricing &&
          <FormRow col="2">
            <Select
              error={errors.actividadCliente}
              setShow={setShowActivity}
              show={showActivity}
              defaultValue={simulator.clientData.actividadCliente?.nombre}
              setSelected={setSelectedActivitie}
              list={activities}
              placeholder="Seleccionar..."
              label="Actividad"
              name="actividadCliente"
              id="actividadCliente"
              register={register({ required: "Este dato es obligatorio" })} />
          </FormRow>

        }

        <FormRow col="2">
       
          {/*pilotoSoyYo &&
            <RadioButtonForm
              label="¿El cliente tiene WhatsApp?"
              setIdentificationRadioChecked={onChangeWhatsApp}
              defaultValue="SI"
              selected={whatsApp}
              name="whatsApp"
              id="whatsApp"
              register={register({ required: "Este dato es obligatorio" })}
              radios={[
                { label: 'SI', value: 'true' },
                { label: 'NO', value: 'false' }
              ]} />
            */}

          <Select
            error={errors.medioContacto}
            show={showContactMean}
            setShow={setShowContactMean}
            defaultValue={simulator.clientData.medioContacto?.nombre}
            setSelected={setContactMean}
            list={contactMeans}
            placeholder="Seleccionar..."
            label="¿Cómo se enteró de ExcelCredit?"
            name="medioContacto"
            id="medioContacto"
            register={register({ required: "Este dato es obligatorio" })} />
            
          <Select
            error={errors.tipoCedula}
            show={showIdType}
            setShow={setShowIdType}
            defaultValue={simulator.clientData.tipoCedula?.nombre}
            setSelected={setIdType}
            list={idTypes}
            placeholder="Seleccionar..."
            label={<div>¿Qué tipo de cédula tiene el cliente? <InfoCircleImage src={infoCircle} alt="info" onClick={(e) => setShowModalIdType(true)} /></div>}
            name="tipoCedula"
            id="tipoCedula"
            register={register({ required: "Este dato es obligatorio" })} />

        </FormRow>
        {/*<div style={{marginTop:'20px'}}>Por favor brindar la siguiente información al cliente:
              <br /><br />
          Estimado cliente, para dar continuidad a su solicitud es necesario que nos autorice el tratamiento de datos personales. Por tal razón, en este momento ExcelCredit le enviará a su WhatsApp y correo electrónico un link para acceder al formato y una vez haga lectura y esté de acuerdo, proceda con la autorización ingresando el código temporal OTP que le llegará en el mismo mensaje.</div>*/}
        <FormRow col="1">
          {/* 
          <CheckBox
            error={errors.permisos}
            defaultValue={false}
            label={<div>Por favor brindar la siguiente información al cliente:
              <br /><br />
              Estimado cliente, para dar continuidad a su solicitud es necesario que nos autorice el tratamiento de datos personales. Por tal razón, en este momento ExcelCredit le enviará a su WhatsApp y correo electrónico un link para acceder al formato y una vez haga lectura y esté de acuerdo, proceda con la autorización ingresando el código temporal OTP que le llegará en el mismo mensaje.</div>}
            name="permiso"
            id="permiso"
            checked={permission}
            onChange={onChangePermission}
            register={register({ required: "Este dato es obligatorio" })} />*/}
        </FormRow>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => setBackStep()} id="back-step">Volver</DefaultLargeButton>

          <StepFourFooterRightSide>
            <TertiaryLargeButton type="button" disabled={!permission} onClick={() => initSolicitation()} id="init-solicitation">Iniciar solicitud</TertiaryLargeButton>
            <SecondaryLargeButton type="button" onClick={() => saveSimulation()} id="save-simulation" disabled={!checkCapacity()}>Guardar simulación</SecondaryLargeButton>
          </StepFourFooterRightSide>
        </FormFooter>
      </Form>
      <LoadingModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        idCredito={idCredito}
        estadoEsperado='PROSPECCION_EXITOSA'
        labels={LABELS}
        closeModal={enableCloseModal ? moveToDashboard : null}
        onError={() => setShowModalFalloTecnico(true)}
        setShowModal={setIsModalOpen}
        />
        <ModalFlujoContinuoError
        title={<div>
          Tu cliente tiene mucha informacion registrada
          <br></br>
          <b>Esto puede tardar un poco mas....</b>
        </div>}
        description={<div>
          Por favor, refresca la página y vuelve a buscar el crédito en la opción
          <b>"Pendiente por radicar" o espera con nosotros</b>
        </div>}
        open={showModalTimeOut} 
        setShowModal={setShowModalTimeOut}
        imgSource={flujoContinuoTimeOutImg}
        onClose={moveToDashboard}
        />
        <ModalFlujoContinuoError
        title={<div>
          <b>Se presentó un error en la consulta a centrales de riesgo</b>
        </div>}
        description={<div>
          Por favor, inicia el proceso nuevamente.
        </div>}
        open={showModalFalloTecnico} 
        setShowModal={setShowModalFalloTecnico}
        imgSource={falloCentralesImg}
        onClose={moveToDashboard}
        />
      <ModalInfo
        open={showModalInfoEdad}
        setShowModal={setShowModalInfoEdad}
        title="El cliente debe tener entre 20 y 84 años."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoCapacity}
        setShowModal={setShowModalInfoCapacity}
        title="Cliente sin capacidad"
        description="Monto solicitado supera la capacidad del cliente."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalActionSendIdValidation
        open={showModalIdValidation}
        actionFunctionDownButton={() => moveToDashboard()}
        title={titleValidation}
        actionLabelFunctionDownButton="Continuar"
        description={messageValidation}
        bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
        backgroundIcon={colors.textHyperlink} />
      <ModalInfo
        open={showModalSoyYo}
        setShowModal={setShowModalSoyYo}
        title="¡Apreciado Aliado Comercial!"
        description={descriptionModalSoyYo}
        backgroundIcon={colors.yellow}
        bodyIcon={<BsCheck size={32} color={colors.white} id="exclamation-icon" />} />
         <ModalInfo
        open={showModalInfoCorreo}
        setShowModal={setShowModalInfoCorreo}
        title="El correo electrónico no coincide"
        description=""
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalInfoImage
            open={showModalIdType}
            setShowModal={() => setShowModalIdType(false)}
            description="La cédula digital identifica a los colombianos desde diciembre de 2020. Se emite en dos formatos: una cédula física en policarbonato, que al ser entregada activa la versión digital."
            bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />}
            backgroundIcon={colors.bgDanger}
            imgSource={imagenCedula}
            title="Cédula Nueva"
          />
        <ModalAction
            open={showModalCambioAsesor}
            setShowModal={setShowModalCambioAsesor}
            actionLabelFunctionUpButton='Si, enviar solicitud'
            actionFunctionUpButton={() => setShowModalCambioAsesor(false)}
            actionLabelFunctionDownButton='Cancelar Solicitud'
            actionFunctionDownButton={() => setShowModalCambioAsesor(false)}
            title={"Estimado asesor "+session.name+","}
            description={<>En este momento no tienes autorización para iniciar la gestión con el cliente. Sin embargo, puedes solicitar un cambio de asesor.
            <br></br>¿Deseas enviar la solicitud de cambio de asesor ahora?</>}
            backgroundIcon={colors.bgDanger}
            bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        <ModalInfo
        open={showModalCorretaje}
        setShowModal={setShowModalCorretaje}
        description={<div style={{textAlign: 'left'}}>Ejecutivo Freelance,<br></br>
        Nos haces falta. Recuerda que La Revolución Neofinanciera viene en camino y llega con más oportunidades 
        comerciales, por eso no olvides que <b>debes firmar la nueva modalidad de contrato</b> para acceder a tus beneficios. 
        Si ya firmaste el nuevo contrato, valida con tu Director de Oficina que todo este bien. Acá estamos para ti y para seguir creciendo juntos 
        ¡No te quedes sin aprovechar esta oportunidad!<br></br>
        <b>Identifica el contrato con el asunto del correo enviado: Signature requested on "Contrato de Corretaje</b>
        </div>}
        backgroundIcon={colors.grayLight}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        {isLoading && <Loader />}
    </FormTemplate>
  )
}

export default ClientDataPage
